<template>
  <div id="modalSubuserUnbindWxBySupplier" class="modal fade">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content bd-0 tx-14">
        <div class="modal-content bd-0 tx-14">
          <div class="modal-header pd-x-20">
            <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
              {{ $t("subuser.解除微信登录") }}
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body pd-20">
            <p>
              {{ $t("subuser.“确认对")
              }}<strong class="text-danger bold pd-l-5 pd-r-5">{{
                item.name
              }}</strong
              >{{ $t("subuser.解除微信授权，将导致无法访问微信服务号？") }}
            </p>
          </div>
          <div class="modal-footer justify-content-center">
            <button
              type="button"
              class="
                btn btn-secondary
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              data-dismiss="modal"
            >
              {{ $t("subuser.取消") }}
            </button>
            <button
              type="button"
              class="
                btn btn-danger
                tx-11 tx-uppercase
                pd-y-12 pd-x-25
                tx-mont tx-semibold
              "
              @click="save()"
            >
              {{ $t("subuser.确定") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    save() {
      this.$parent.loading = true;
      $.api_call(
        "api.SubUser.unbindWx",
        {
          subUserId: Number(this.item.id),
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            ShowTip(this.$t("subuser.该子账号已成功解除微信"), "success");
            $("#modalSubuserUnbindWxBySupplier").modal("hide");
            this.$parent.getSubuserList();
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>